"use strict";

const TreatmentStepFormCtrl = function ($state, PatientsService, config) {
  var ctrl = this;

    // model for new treatment action forms
    ctrl.model = {
      region: 'ARTERIAL'
    };

    ctrl.requestForm = function(){
      // request a new treatment action
      PatientsService.requestTreatmentForm(ctrl.treatment.uuid, ctrl.model).then(function(response){
        var action = response.data;

        // get form schema
        PatientsService.getTreatmentForm(ctrl.treatment.uuid, response.data.uuid).then(function(response){
          $state.go('main.patients.formview', {
            schema: response.data,
            data: action.data,
            treatment: ctrl.treatment,
            action: action,
            actionId: action.uuid,
            treatId: ctrl.treatment.uuid,
            pid: ctrl.patient.pid});
        });
      });
    };

    // get possible treatment actions
    ctrl.getTreatactions = function(treatment){
      var data = {
        'INTERVENTION': config.labels['INTERVENTION'],
        'POSTINTERVATIONELLENACHKONTROLLE': config.labels['POSTINTERVATIONELLENACHKONTROLLE'],
        'FOLLOWUP': config.labels['FOLLOWUP']        
      };

      // check if an anamnesis is already given
      for (var action in treatment.actions){
        if (treatment.actions[action].schema.action === 'ANAMNESIS'){
          if (!ctrl.model.action) {
            ctrl.model.action = 'INTERVENTION';
          }
          return data;
        }
      }

      data.ANAMNESIS = config.labels['ANAMNESIS'];
      if (!ctrl.model.action) {
        ctrl.model.action = 'ANAMNESIS';
      }

      return data;
    };
  };

TreatmentStepFormCtrl.$inject = ['$state', 'PatientsService', 'config'];

module.exports = {
  template: require('./treataction.html'),
  bindings: {
    patient: '<',
    treatment: '<'
  },
  controller: TreatmentStepFormCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/patients/components/form-treatment-step/form-treatment-step.component.js